import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MaterialModule } from '../material/material.module';
import { FeesComparisonDisplayComponent } from './fees-comparison-display.component';

@NgModule({
    declarations: [FeesComparisonDisplayComponent],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MaterialModule
    ],
    exports: [FeesComparisonDisplayComponent]
})
export class FeesComparisonDisplayModule { }
